import { render, staticRenderFns } from "./WaitingForVerificationView.vue?vue&type=template&id=2e96d743"
import script from "./WaitingForVerificationView.vue?vue&type=script&lang=ts"
export * from "./WaitingForVerificationView.vue?vue&type=script&lang=ts"
import style0 from "./WaitingForVerificationView.vue?vue&type=style&index=0&id=2e96d743&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports